export const isLoading = (isFetchingList: string[], dataName: string) => {
  return isFetchingList.includes(dataName);
};
